export function downloadFileUrl(url: string, name?: string | null | undefined) {
	const link = document.createElement('a');
	link.href = url;
	if (name) {
		link.download = name;
	}
	link.click();
}
